import Marquee from "react-fast-marquee";
import { FadeUp } from "./Reveal";
import { useLightbox } from "./Lightbox";

export const KITCHEN_PHOTOS = [
  { src: "/images/work-kitchen-1.webp", alt: "Straight modular kitchen with warm under-cabinet lighting" },
  { src: "/images/work-kitchen-2.webp", alt: "Grey kitchen with backlit glass display cabinets" },
  { src: "/images/work-kitchen-3.webp", alt: "Cream crockery unit with fluted shutters" },
  { src: "/images/work-kitchen-4.webp", alt: "L-shaped modular kitchen with fluted glass tall units" },
  { src: "/images/work-kitchen-5.jpg", alt: "Pastel blue L-shaped modular kitchen" },
  { src: "/images/work-kitchen-6.webp", alt: "Teal island kitchen with breakfast counter and bar stools" },
  { src: "/images/work-kitchen-7.webp", alt: "Kitchen with backlit display cabinets and profile lighting" },
  { src: "/images/work-kitchen-8.webp", alt: "Tall storage unit with open display shelf" },
  { src: "/images/work-kitchen-9.webp", alt: "Handleless kitchen with marble backsplash and glass wall cabinets" },
  { src: "/images/work-kitchen-10.webp", alt: "Mint and white modular kitchen with terrazzo backsplash" },
  { src: "/images/work-kitchen-11.webp", alt: "Mint and white L-shaped modular kitchen, second angle" },
];

export const SPACE_PHOTOS = [
  { src: "/images/work-space-1.webp", alt: "Floor-to-ceiling wardrobe wall with dressing mirror" },
  { src: "/images/work-space-2.webp", alt: "Walnut study unit with bookshelf and storage" },
  { src: "/images/work-space-3.webp", alt: "Full-wall walnut sliding wardrobe" },
  { src: "/images/work-space-4.webp", alt: "Grey textured TV wall unit with storage" },
  { src: "/images/work-space-5.webp", alt: "Bedroom with window seat, study desk and wardrobe" },
  { src: "/images/work-space-6.webp", alt: "Green and white TV console with gold pendant lights" },
  { src: "/images/work-space-7.webp", alt: "Light grey full-wall wardrobe with mirrored dresser" },
  { src: "/images/work-space-8.webp", alt: "Full-length wardrobe run with TV niche along hallway" },
  { src: "/images/work-space-9.webp", alt: "Walnut and white sliding wardrobe with mirrored dresser" },
  { src: "/images/work-space-10.webp", alt: "Glossy wardrobe with study desk and wall shelves" },
];

export default function MediaRibbon({ photos, label, testId, direction = "left" }) {
  const { open } = useLightbox();
  const items = photos.map((p) => ({ ...p, caption: `${label.split("—")[0].trim()} — STAR AVG ENTERPRISE` }));
  return (
    <section data-testid={testId} className="overflow-hidden border-y border-line bg-sand py-6 lg:py-10">
      <FadeUp>
        <p className="mx-auto mb-6 flex max-w-[1400px] items-center gap-3 px-6 text-[11px] font-semibold uppercase tracking-[0.35em] text-taupe lg:px-12">
          <span className="inline-block h-2 w-2 bg-terra" />
          {label}
          <span className="ml-auto hidden normal-case tracking-normal text-taupe/70 sm:inline">
            Tap any photo to view full-screen
          </span>
        </p>
      </FadeUp>
      <Marquee speed={40} gradient={false} pauseOnHover direction={direction}>
        {photos.map((p, i) => (
          <img
            key={p.src}
            src={p.src}
            alt={p.alt}
            loading="lazy"
            data-testid={`${testId}-photo-${i + 1}`}
            onClick={() => open(items, i)}
            className="mr-3 h-44 w-auto cursor-zoom-in object-cover transition-transform duration-500 hover:scale-[1.02] md:h-64 lg:h-72"
          />
        ))}
      </Marquee>
    </section>
  );
}
